import { MantineProvider } from '@mantine/core';
import '@mantine/core/esm/index.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import store from './store/store';
import './global.css';

const root = createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <MantineProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </MantineProvider>
  </BrowserRouter>
);
